import { Box, type BoxProps, Flex, Text } from '@mantine/core'

import { TextDate } from '@flecto/ui'

import { useDocumentState } from '../../../booking-documents/hooks/useDocumentState'
import { SectionTable } from './SectionTable'

type SectionCustomerProps = BoxProps

export function SectionCustomer({ ...props }: SectionCustomerProps) {
  const { documentPreview, translate } = useDocumentState()

  return (
    documentPreview?.booking_settings
      ?.documents_contract_include_customer_details && (
      <SectionTable {...props}>
        <SectionTable.Header>
          <Text w='60%' fw={500} size='md'>
            {translate?.('label_customer')}
          </Text>
          <Text w='40%' fw={500} size='md'>
            {translate?.('label_booking', {
              id: documentPreview?.booking?.internal_id,
            })}
          </Text>
        </SectionTable.Header>
        <SectionTable.Body>
          <Flex>
            <Box w='60%'>
              <Flex mt='xs' direction='column'>
                <Text fw={500} size='md'>
                  {documentPreview?.customer?.full_name}
                </Text>
                {documentPreview?.customer?.phone_number && (
                  <Text size='md'>
                    {translate?.('label_customer_phone')}:{' '}
                    {documentPreview?.customer?.phone_number}
                  </Text>
                )}
                {documentPreview?.customer?.vat_number && (
                  <Text size='md'>
                    {translate?.('label_customer_vat')}:{' '}
                    {documentPreview?.customer?.vat_number}
                  </Text>
                )}
                {documentPreview?.customer?.email && (
                  <Text size='md'>
                    {translate?.('label_customer_email')}:{' '}
                    {documentPreview?.customer?.email}
                  </Text>
                )}
              </Flex>
            </Box>
            <Box w='40%'>
              <Flex align='center' gap='xs' mt='xs'>
                <Text fw={500} size='md'>
                  {translate?.('label_pickup')}:
                </Text>
                <TextDate
                  date={documentPreview?.booking?.start_at ?? ''}
                  variant='datetime-brief'
                  size='md'
                />
              </Flex>
              <Flex align='center' gap='xs' mt='xs'>
                <Text fw={500} size='md'>
                  {translate?.('label_return')}:{' '}
                </Text>
                <TextDate
                  date={documentPreview?.booking?.end_at ?? ''}
                  variant='datetime-brief'
                  size='md'
                />
              </Flex>
            </Box>
          </Flex>
        </SectionTable.Body>
      </SectionTable>
    )
  )
}
